import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['stat']
  static values = {
    url: String,
    interval: { type: Number, default: 30000 }
  }

  connect() {
    this.refresh()
    this.timer = setInterval(() => this.refresh(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  async refresh() {
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: 'application/json' } })
      if (!response.ok) return
      const stats = await response.json()
      this.statTargets.forEach((element) => {
        const value = stats[element.dataset.stat]
        if (value !== undefined) element.textContent = value
      })
    } catch {
      // A failed poll keeps the last rendered numbers; the next tick retries.
    }
  }
}
